import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Spinner } from "react-bootstrap";
import TabellaLista from '../../../../components/Tabella/TabellaLista';
import { ChipFilter, filtroMultiplo } from '../../../../components/Tabella/ChipFilter';
import MyApiClient from '../../../../../api-client/MyApiClient';
import { sports } from "../../../../components/Util/enum";
import { useNavigate } from 'react-router-dom';
import { formattaPrezzo } from "../../../../components/Util/prezzi";

// Valori dei filtri a chip, come compaiono nella lista.
const MULTI_CORSO_OPTIONS = ['Sì', 'No'];
const STATO_OPTIONS = ['Attivo', 'Non attivo'];

export const FacilitiesTable = () => {

	const navigate = useNavigate();
	const [data_json, setDataJson] = useState(null);
	const [sportFilter, setSportFilter] = useState('');
	// Chip a scelta multipla: all'inizio tutti accesi
	const [multiCorsoFilter, setMultiCorsoFilter] = useState(MULTI_CORSO_OPTIONS);
	const [statoFilter, setStatoFilter] = useState(STATO_OPTIONS);

	// Gli sport sono quelli degli impianti caricati: di solito pochi per struttura.
	const sportOptions = useMemo(
		() => [...new Set((data_json || []).map((row) => row.sportType).filter(Boolean))].sort(),
		[data_json],
	);

	const filteredData = useMemo(
		() =>
			data_json &&
			data_json.filter(
				(row) =>
					(!sportFilter || row.sportType === sportFilter) &&
					filtroMultiplo(multiCorsoFilter, MULTI_CORSO_OPTIONS, row.multiCourse ? 'Sì' : 'No') &&
					filtroMultiplo(statoFilter, STATO_OPTIONS, row.status_label?.label),
			),
		[data_json, sportFilter, multiCorsoFilter, statoFilter],
	);

	const [loadingShowed, setLoadingShowed] = useState(false);

    // Colonna "Prezzo soci/tesserati": visibile solo per ASD/SSD (matrice regole clubNature)
    let clubNatureFromSession = null;
    try { clubNatureFromSession = JSON.parse(sessionStorage.getItem('userDetails'))?.clubNature; } catch (e) { clubNatureFromSession = null; }
    const showSociTesseratiColumn = clubNatureFromSession === 'ASD' || clubNatureFromSession === 'SSD';

    const data_column = [
		{
			Header: 'Impianto / Ritrovo',
			Footer: 'Impianto / Ritrovo',
			accessor: 'name',
		},
		{
			Header: 'Sport',
			Footer: 'Sport',
			accessor: 'sportType',
			disableGlobalFilter: true,
		},
		{
			Header: 'Multi Corso',
			Footer: 'Multi Corso',
			accessor: 'multiCourse',
			disableGlobalFilter: true,
			Cell: ({ value }) => value ? 'Sì' : 'No'
		},
		{
			Header: 'Prezzo Standard',
			Footer: 'Prezzo Standard',
			accessor: 'standard_price',
			disableGlobalFilter: true,
		},
		...(showSociTesseratiColumn ? [{
			Header: 'Prezzo soci/tesserati',
			Footer: 'Prezzo soci/tesserati',
			accessor: 'federated_price',
			disableGlobalFilter: true,
		}] : []),
		{
			Header: 'N. Vendite',
			Footer: 'N. Vendite',
			accessor: 'purchasesCount',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return value || 0;
			},
			disableFilters: true,
		},
		{
			Header: 'Stato',
			Footer: 'Stato',
			accessor: 'status_label',
			disableGlobalFilter: true,
			Cell: ({ value }) => {
				return (
					<div className="d-flex align-items-center">
						<i className={`fa fa-circle me-1 ${value?value.class:''}`}></i>
						{value?value.label:''}
					</div>
				)
			},
			disableFilters: true,
		},
	];

	function openDetail(row) {
		navigate('/struttura/booking/facilitiesedit/'+row.id);
	}

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    let token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const [venues, userVenues] = await Promise.all([
                        apiClient.getVenues(token),
                        apiClient.getUserBookingVenues(token)
                    ]);
					setLoadingShowed(false);

					if(venues) {
						// Conteggio acquisti per impianto
						let purchasesByVenue = {};
						if(Array.isArray(userVenues)) {
							userVenues.forEach(uv => {
								const venueId = uv.venue_id || uv.venueId;
								if(venueId) {
									purchasesByVenue[venueId] = (purchasesByVenue[venueId] || 0) + 1;
								}
							});
						}

						let data = [];
						venues.forEach(element => {

							let sportLabel = '';
							sports.forEach(element2 => {
								if(element2.value === element.sportType) {
									sportLabel = element2.label;
								}
							});

							let status = element.showToCustomers
								? { "label": "Attivo", "class": "text-success" }
								: { "label": "Non attivo", "class": "text-primary" };

							let row = {
								"id": element.id,
								"name": element.name,
								"description": element.description,
								"sportType": sportLabel,
								"multiCourse": element.multiCourse || false,
								"showToCustomers": element.showToCustomers || false,
								"standard_price": formattaPrezzo(element.standard_price),
								"federated_price": formattaPrezzo(element.federated_price),
								"purchasesCount": purchasesByVenue[element.id] || 0,
								"status_label": status
							};
							data.push(row);

						});
						setDataJson(data);
					}
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();

    }, []);





    return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

<TabellaLista
				pageList={true}
				cardTitle={'Impianti'}
				hasSearch={true}
				searchPlaceholder={'Cerca per impianto o ritrovo'}
				hasFilter={false}
				filterControl={
					<div className="sid-chip-filters">
						{sportOptions.length > 1 && <ChipFilter label="Sport" options={sportOptions} value={sportFilter} onChange={setSportFilter} asDropdown />}
						<ChipFilter label="Multi corso" options={MULTI_CORSO_OPTIONS} value={multiCorsoFilter} onChange={setMultiCorsoFilter} multiple />
						<ChipFilter label="Stato" options={STATO_OPTIONS} value={statoFilter} onChange={setStatoFilter} multiple />
					</div>
				}
				data_column={data_column}
				data_json={filteredData}
				openColumn={'name'}
				openRow={(row) => openDetail(row)}
				hasAddMore={true}
				linkAddMore={'/struttura/booking/facilities/new'}
				labelAddMore={'Nuovo impianto'}
				sort_by={'name'}
                sort_type={'asc'}
				modalCallBack={() => setModalCentered(true)}
			/>
		</>
	)
};

export default FacilitiesTable;